// import { computed } from "vue";
import { useStoreItem } from "../itemStore.store";
import { effectItemStructure, useEffectStore } from "./effects.store";

export const useEffect = useStoreItem(
  effectItemStructure,
  useEffectStore,
  (effect, store) => {
    return {};
  }
);
